/* Main kiwi skin renderer — layers environment, variant, artifact, and effect.
 * Replaces the old KiwiSkin component from KiwiSkinSystem. */

import type { KiwiSkinConfig } from "@/types/kiwiSkin";
import { PALETTES } from "./kiwiPalettes";
import { VARIANT_RENDERERS } from "./kiwi-variants";
import { renderEnvironment } from "./kiwi-elements/renderEnvironment";
import { renderArtifact } from "./kiwi-elements/renderArtifact";
import { renderEffect } from "./kiwi-elements/renderEffect";

interface KiwiSkinRendererProps {
  config: KiwiSkinConfig;
  className?: string;
  style?: React.CSSProperties;
}

export function KiwiSkinRenderer({ config, className, style }: KiwiSkinRendererProps) {
  const palette = PALETTES[config.palette];
  const renderVariant = VARIANT_RENDERERS[config.variant];

  if (!palette || !renderVariant) {
    // Fallback for unknown variant/palette (e.g. old DB records before migration)
    return (
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
        <circle cx="16" cy="16" r="10" fill="#666" opacity="0.3" />
        <text x="16" y="18" textAnchor="middle" fontSize="8" fill="#999">?</text>
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      {renderEnvironment(palette, config.environment)}
      {renderVariant(palette)}
      {renderArtifact(palette, config.artifact)}
      {renderEffect(palette, config.effect)}
    </svg>
  );
}
